// extracted by mini-css-extract-plugin
export var cartContainer = "_ok-4";
export var gray = "_ok-1";
export var itemContainer = "_ok-2";
export var itemDetails = "_ok-3";
export var strong = "_ok-0";